import axiosInstance from '../axios/axiosInstance';

export const ADDITIONAL_PAGE_SIZE = 20;

export function firstApiError(error) {
    const data = error?.response?.data;
    const errors = data?.errors;
    if (errors && typeof errors === 'object') {
        const first = Object.values(errors).flat().find(Boolean);
        if (first) return String(first);
    }
    return data?.message || null;
}

export function apiFieldErrors(error) {
    const errors = error?.response?.data?.errors;
    if (!errors || typeof errors !== 'object') return {};
    const mapped = {};
    Object.entries(errors).forEach(([key, value]) => {
        mapped[key] = Array.isArray(value) ? value[0] : value;
    });
    return mapped;
}

function unwrapItem(payload) {
    const data = payload?.data;
    if (data && !Array.isArray(data) && data.id != null) return data;
    return data ?? payload;
}

function unwrapList(payload) {
    const body = payload ?? {};
    const items = Array.isArray(body.data) ? body.data : [];
    const meta = body.meta ?? {};
    return {
        items,
        count: Number(body.count ?? meta.total ?? items.length) || 0,
        meta,
        pagination: {
            current: Number(meta.current_page ?? 1) || 1,
            pageSize: Number(meta.per_page ?? ADDITIONAL_PAGE_SIZE) || ADDITIONAL_PAGE_SIZE,
            total: Number(meta.total ?? body.count ?? items.length) || 0,
        },
    };
}

function listParams({ search = '', includeDeleted = false, page = 1, perPage = ADDITIONAL_PAGE_SIZE } = {}) {
    const params = { page, per_page: perPage };
    if (search) params.search = search;
    if (includeDeleted) params.include_deleted = 1;
    return params;
}

export async function fetchAdditionalServices(query) {
    const response = await axiosInstance.get('/admin/additional-services', { params: listParams(query) });
    return unwrapList(response.data);
}

export async function fetchAdditionalService(id) {
    const response = await axiosInstance.get(`/admin/additional-services/${id}`);
    return unwrapItem(response.data);
}

export async function createAdditionalService(body) {
    const response = await axiosInstance.post('/admin/additional-services', body);
    return unwrapItem(response.data);
}

export async function updateAdditionalService(id, body) {
    const response = await axiosInstance.patch(`/admin/additional-services/${id}`, body);
    return unwrapItem(response.data);
}

export async function deleteAdditionalService(id) {
    await axiosInstance.delete(`/admin/additional-services/${id}`);
}

export async function fetchAdditionalServiceHistory(id, { page = 1, perPage = ADDITIONAL_PAGE_SIZE } = {}) {
    const response = await axiosInstance.get(`/admin/additional-services/${id}/history`, {
        params: { page, per_page: perPage },
    });
    return unwrapList(response.data);
}

export function formatServicePrice(value) {
    if (value == null || value === '') return null;
    const n = Number(value);
    if (Number.isNaN(n)) return String(value);
    return n.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
